import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import MarkupBundleDetail from './MarkupBundleDetail';
import * as markupBundleActions from './../../../../../actions/markupBundleAction';
import * as rateActions from './../../../../../actions/rateAction';
import * as hotelActions from './../../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        markupBundleState: state.markupBundleReducer,
        hotelState: state.hotelReducer,
        rateState: state.rateReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMarkupBundleDetail: (id) => dispatch(markupBundleActions.getMarkupBundleDetail(id)),
        setMarkupBundleDetail: (markupBundle) => dispatch(markupBundleActions.setMarkupBundleDetail(markupBundle)),
        updateMarkupBundleDetail: (markupBundle) => dispatch(markupBundleActions.updateMarkupBundleDetail(markupBundle)),
        createMarkupBundleDetail: (markupBundle) => dispatch(markupBundleActions.createMarkupBundleDetail(markupBundle)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MarkupBundleDetail));
